import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

import { AppComponent } from './app.component';
import { AuthInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';
import { BridgeDialogComponent } from './bridge-dialog.component';
import { PlotCardComponent } from './plot-card.component';
import { PlotEditorDialogComponent } from './plot-editor-dialog.component';
import { DataPreviewComponent } from './data-preview.component';
import { QueryResultComponent } from './query-result.component';
import { QueryTestDialogComponent } from './query-test-dialog.component';
import { PystEditorComponent } from './pyst-editor.component';
import { QueryBuilderDialogComponent } from './query-builder-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        PlotCardComponent,
        PlotEditorDialogComponent,
        BridgeDialogComponent,
        QueryBuilderDialogComponent,
        PystEditorComponent,
        DataPreviewComponent,
        QueryResultComponent,
        QueryTestDialogComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatMenuModule,
        MatSnackBarModule,
        MatTabsModule,
        MatToolbarModule,
    ],
    providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
